import * as React from 'react';
import { Modal, Title, Button } from '../../modules/modules';
import CountryService from '../../services/CountryService';
import Form from '../FormGenerator/Form';
import { inquiryFields } from '../../formFields';
import FlashStore from '../../services/FlashStore';

interface IInquiryFormProps {
  product: GQL.IProduct;
  variant: GQL.IProductVariant;
  userInfo?: any;
  onClose: () => void;
  inquiryForm: (data: any) => void;
}

interface IInquiryFormState {
  formFields: any[];
  formValues: any;
  sending: boolean;
}

export default class InquiryForm extends React.PureComponent<IInquiryFormProps, IInquiryFormState> {

  private form: any;

  constructor(props: IInquiryFormProps) {
    super(props);

    this.state = {
      formFields: inquiryFields,
      formValues: {},
      sending: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.onClose = this.onClose.bind(this);
  }

  public componentWillReceiveProps(nextProps: IInquiryFormProps) {
    const { userInfo } = nextProps;
    if (userInfo && !userInfo.loading && userInfo.userInfo) {
      this.setState({
        formValues: {
          FirstName: userInfo.userInfo.invoiceFirstName,
          LastName: userInfo.userInfo.invoiceLastName,
          Phone: userInfo.userInfo.phone,
          Email: userInfo.userInfo.email,
        }
      });
    }
  }

  public render() {
    const { product } = this.props;
    const { formFields, formValues } = this.state;
    const { language } = CountryService.GetInstance();

    return (
      <React.Fragment>
        <Modal 
          open={true}
          type="inquiryForm"
          onClose={this.onClose}
          disableScrollBody={true}
        >
          <div className="modal__box">
            <div className="modal__head">
              <div className="modal__title">Inquiry form</div>
              <button className="modal__close" onClick={this.onClose} />
            </div>
            <div className="modal__body">

              <Title>{product.name[language]}</Title>
              
              <div className="row">
                <div className="col-12">
                  <div className="form form--inquiry">
                    <Form
                      type="inquiry"
                      fields={formFields}
                      values={formValues} 
                      handleChange={this.handleChange}
                    >
                      {(form: any) => {
                        this.form = form;
                        return null;
                      }}
                    </Form>
                  </div>
                </div>
              </div>

            </div>
            <div className="modal__footer">
              <Button 
                type="sm" 
                onClick={() => {
                  this.handleSend(this.form);
                }}
              >
                Send inquiry
              </Button>
            </div>
          </div>
        </Modal>
      </React.Fragment>
    );
  }

  private onClose() {
    if (document) {
      document.body.style.overflow = '';
    }
    this.props.onClose();
  }

  private changeFields(fields: any[]) {
    this.setState({
      formFields: [...fields],
    });
  }

  public handleChange(value: any, field: string) {
    this.setState({ formValues: { ...this.state.formValues, [field]: value } });
  }

  private async handleSend(form: any) {
    const { countryCode } = CountryService.GetInstance();
    
    const { formValues } = this.state;

    const validation = await form.validate((fields: any) => {
      this.changeFields(fields);
    });

    if (validation && this.props.inquiryForm) {
      // indikace odesílání
      this.setState({
        sending: true,
      }, async () => {
        // odeslání formuláře
        await this.props.inquiryForm({
          variables: { 
            data: {
              productId: this.props.product.id,
              firstName: formValues.FirstName,
              lastName: formValues.LastName,
              phone: formValues.Phone,
              email: formValues.Email,
              note: formValues.Note,
            },
            countryCode,
          }
        });

        // notifikace
        FlashStore.GetInstance().showMessage(
          `Your request has been sent`,
          'success',
          6000
        );

        // konec
        this.setState({
          sending: false,
        });

        // odesláno
        this.onClose();
      });
      
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/InquiryForm/InquiryForm.tsx